import { styled } from 'styled-components';
import { device } from '../styles/stylesConfig';
import { useAnimations } from '../effects/Effects';
import { useLogEvent } from '../hooks/useLogEvent';
import { memo } from 'react';

const LogoContainer = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    transition: all 0.75s;
    padding: 0;
    cursor: pointer;
    position: relative;
    justify-self: start;
`

const LogoImage = styled.img`
    width: auto;
    height: 90px;

    @media ${device.lg} {
        width: auto;
        height: 60px;
    }

`

const AppLogo = () => {

    const {
        handleClickGoHome
    } = useAnimations()

    const { handleLogEvent } = useLogEvent();

    return (

        <LogoContainer
            onClick={async () => {

                handleClickGoHome()

                handleLogEvent('click_logo');

            }}
        >

            <LogoImage
                src={require('../images/logo-blanco.png')}
                alt='logo'
            />

        </LogoContainer>

    )
}

const AppLogoComponent = memo(AppLogo);

export default AppLogoComponent;